<script>
import { onMounted, computed } from '@vue/composition-api'
import ClassBtn from './ClassBtn.vue'
import getCountDown from './countdown'
import { formatTime } from '@/utils/time'
import { EXTRA_TIME } from './constant'
/**
 * 定帧题
 */
export default {
  name: 'DingzhenQue',
  components: {
    ClassBtn
  },
  props: {
    event: Object
  },
  setup(props, { root, refs, emit }) {
    // 显示时长为生产平台实际配置时长单位秒+3s反馈时长
    const { countdown, start } = getCountDown(EXTRA_TIME)
    const countdownDesc = computed(() => formatTime(countdown.value, 'mm:ss'))
    function realEnd() {
      emit('realEnd')
    }
    function end() {
      emit('end')
    }
    onMounted(() => {
      start(props.event.params.duration, () => {
        // TODO 倒计时结束如何处理
      })
    })
    return {
      countdownDesc,
      realEnd,
      end
    }
  }
}
</script>
<template>
  <div class="ding-zhen-que">
    <dl>
      <dt>学员正在参与普通答题互动</dt>
      <dd>{{ countdownDesc }}</dd>
    </dl>
    <ClassBtn @realEnd="realEnd" @end="end" />
  </div>
</template>
<style lang="less" scoped>
.ding-zhen-que {
  position: absolute;
  z-index: 2;
  bottom: 40px;
  right: 40px;
  background: rgba(36, 39, 49, 0.8);
  border-radius: 16px;
  color: #fff;
  justify-content: flex-end;
  align-items: center;
  box-sizing: content-box;
  height: 48px;
  padding: 24px 30px;
  display: flex;
  > dl {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    dt {
      font-size: 18px;
    }
    dd {
      font-size: 14px;
    }
  }
}
</style>
